import { RootState } from '@app/model';

export const selectDeletedBooks = ({ bookDeletion: { deletedBooks } }: RootState) => deletedBooks;

export const selectModalIsOpen = ({ bookDeletion: { modalIsOpen } }: RootState) => modalIsOpen;
export const selectDeletedBookId = ({ bookDeletion: { deletedBookId } }: RootState) => deletedBookId;
